import React, { useState } from "react";
import { IMAGE_BASE_URL } from "../../config/api";
import { useNavigate } from "react-router-dom";
import DeletConfirmation from "../../atoms/deletConfirmation";
import { deleteWorker, removeProjectAllocation } from "../../services/service";
import { useSelector } from 'react-redux';
import { selectCurrentPlan } from '../../redux/selectors/authSelectors';
import UpgradePromptModal from '../../components/common/UpgradePromptModal';
import { FEATURE_REQUIRED_PLANS } from '../../utils/planFeatureAccess';
import { StatsIcon } from '../../assets/icons';

const WorkerProfile = ({
  handleOpenProjectSidebar,
  workerData,
  handleOpen,
  setDeleteSuccess,
  deleteSuccess,
  fetchWorker,
  handleOpenReport,
}) => {
  const fullBio = workerData?.detail?.bio;
  const [isBioExpanded, setIsBioExpanded] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteProjectVisible, setIsDeleteProjectVisible] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [restrictedFeature, setRestrictedFeature] = useState(null);
  const currentPlan = useSelector(selectCurrentPlan);

  const bioLength = 220;
  const shouldShowMoreButton = fullBio?.length > bioLength;

  const handleDeleteProjectClick = (id) => {
    if (!id) return;
    setSelectedProjectId(id);
    setIsDeleteProjectVisible(true);
  };

  const handleProjectDelete = async () => {
    if (!selectedProjectId) return;
    setLoading(true);
    const data = {
      project_id: selectedProjectId,
      user_id: workerData?.detail?.id,
    };
    try {
      const response = await removeProjectAllocation(data);
      closeModal();
      fetchWorker(true);
      setDeleteSuccess(!deleteSuccess);
    } catch (error) {
      console.error("Error assigning worker:", error);
      setIsDeleteModalVisible(false);
    } finally {
      setLoading(false);
    }
    
  };
  const handleDeleteClick = () => {
    setIsDeleteModalVisible(true);
  };
  const handleEditClick = () => {
    navigate("/add-worker", { state: { workerId:workerData?.detail?.id } });
  };

  const closeModal = () => {
    setIsDeleteModalVisible(false);
    setIsDeleteProjectVisible(false);
    setSelectedProjectId(null);
  };

  const handleDelete = async () => {
    setIsLoading(true);
    await deleteWorker(workerData?.detail?.id);
    setIsLoading(false);
    closeModal();
    navigate("/view-worker");
  };
  const navigate = useNavigate();

  const toggleBio = () => {
    setIsBioExpanded(!isBioExpanded);
  };

  const data = workerData?.AllocatedProjects;

  const handleProgressEyeClick = () => {
    navigate("/worker-progress", { state: { workerId: workerData?.detail?.id } });
  };

  // Filter out deleted project allocations
  console.log(workerData,"workerData?.AllocatedProjects")
  const activeProjects = workerData?.detail?.AllocatedProjects||[];

  // Helper function to handle empty values
  const getDisplayValue = (value, defaultValue = 'N/A') => {
    return value || defaultValue;
  };

  const canAccessFeature = (feature) => {
    const planLevels = {
      'trial': 0,
      'basic': 1,
      'premium': 2,
      'ultimate': 3
    };
    return planLevels[currentPlan] >= planLevels[FEATURE_REQUIRED_PLANS[feature]];
  };

  const handleRestrictedFeature = (featureName, requiredPlan) => {
    setRestrictedFeature({
      name: featureName,
      requiredPlan: requiredPlan.charAt(0).toUpperCase() + requiredPlan.slice(1)
    });
    setShowUpgradeModal(true);
  };
console.log(workerData,'worker data')
  return (
    <div className="w-full flex gap-5 items-start justify-start">
      <div className="w-[60%] h-[459px] overflow-y-scroll bg-white rounded-[8px] p-4 relative">
        <button
          onClick={handleOpenReport}
          className="absolute top-4 right-4 font-medium px-4 h-[32px] text-[13px] bg-[#1E3A8A] text-white rounded-[4px] hover:bg-[#172e6e] transition-colors flex items-center gap-1"
        >
          <span className="[&>svg]:w-4 [&>svg]:h-4 [&_path]:stroke-white">{StatsIcon}</span>
          Generate Report
        </button>
        <div className="flex items-start gap-4">
          <div className="w-[92px] h-[92px] rounded-full bg-green-500 flex items-center justify-center text-[40px] font-semibold text-white">
            {workerData?.detail?.image ? (
              <img
                src={IMAGE_BASE_URL + workerData?.detail?.image}
                alt="Profile"
                className="h-full w-full rounded-full"
              />
            ) : (
              workerData?.detail?.username
                ?.split(" ")
                ?.map((n) => n[0])
                .join("")
                .toUpperCase()
            )}
          </div>

          <div className="flex flex-col items-start gap-2">
            <div className="flex items-center gap-2">
              <h2 className="font-normal text-[14px] text-start text-black">
                {workerData?.detail?.username}
              </h2>
            </div>
            <p className="font-normal text-[14px] text-start text-black">
              {workerData?.detail?.email}
            </p>
            <p className="font-normal text-[14px] text-start text-black">
              {workerData?.detail?.phoneNo}
            </p>
            <p className="font-normal text-[14px] text-start text-black">
              {getDisplayValue(workerData?.detail?.experience)}{" "}
              <span className="font-semibold">Years of experience</span>
            </p>
            <p className="font-normal text-[14px] text-start text-black capitalize">
              {workerData?.detail?.gender}
            </p>
          </div>
        </div>
        <div className="flex w-full items-center justify-center gap-3 mt-2">
          <div className="w-[0%] flex items-center gap-2"></div>
          <span className="font-normal text-[14px] text-black text-justify">
            {getDisplayValue(workerData?.detail?.expertise)}
          </span>
          <span className="font-semibold text-[14px] text-black">
            Expertise
          </span>
        </div>

        

        <div className="w-full flex justify-center items-center space-x-12 mt-2">
          <div className="flex flex-col gap-1 items-start">
            <p className="font-semibold text-[14px] text-black">Progress</p>
            <p
              className="font-semibold text-[14px] text-[#1E3A8A] cursor-pointer underline"
              onClick={handleProgressEyeClick}
            >
              View Progress
            </p>
          </div>
          <div className="flex flex-col gap-1 items-start">
            <p className="font-semibold text-[14px] text-black">Daily Stats</p>
            <p
              onClick={() => {
                if (!canAccessFeature('workerStats')) {
                  handleRestrictedFeature('Worker Stats', 'basic');
                  return;
                }
                handleOpen();
              }}
              className={`font-semibold text-[14px] cursor-pointer text-[#1E3A8A] underline
                ${!canAccessFeature('workerStats') ? 'opacity-50' : ''}`}
            >
              View Stats
            </p>
          </div>
        </div>

        <div className="space-y-2 mt-2">
          <h3 className="font-semibold text-[14px] text-black">Bio</h3>
          <p className="font-normal text-[14px] text-black transition-all duration-300 ease-in-out">
            {fullBio ? (
              <>
                {shouldShowMoreButton && !isBioExpanded
                  ? `${fullBio?.substring(0, bioLength)}...`
                  : fullBio}
                {shouldShowMoreButton && (
                  <button
                    onClick={toggleBio}
                    className="text-blue-600 hover:underline ml-1"
                  >
                    {isBioExpanded ? "Show Less" : "Show More"}
                  </button>
                )}
              </>
            ) : (
              'N/A'
            )}
          </p>
        </div>

        <div className="flex gap-2 mt-4">
          <button
            onClick={handleEditClick}
            className="font-medium w-[59px] h-[32px] text-[13px] bg-[#F97316] text-white rounded-[4px] hover:bg-[#EA580C] transition-colors"
          >
            Edit
          </button>
          <button
            onClick={handleDeleteClick}
            className="font-medium w-[76px] h-[32px] text-[13px] bg-[#E90C0C] text-white rounded-[4px] hover:bg-[#c70a0a] transition-colors"
          >
            Delete
          </button>
        </div>
      </div>

      <div className="w-[40%] h-[459px] flex flex-col gap-2 bg-white rounded-[8px] overflow-y-scroll">
        <div className="w-full flex items-center justify-between pt-3 px-3">
          <p className="text-base font-semibold text-[#1E3A8A]">
            Projects ({activeProjects?.length})
          </p>
          <button
            onClick={handleOpenProjectSidebar}
            className="w-[110px] h-[24px] rounded-[4px] bg-[#F97316] text-[13px] text-white font-medium hover:bg-orange-600 transition-colors"
          >
            Assign Project
          </button>
        </div>
        {activeProjects?.length === 0 && <div className="flex items-center justify-center h-full">
          <p className="text-gray-500">No projects found</p>
        </div>}
        {activeProjects?.map((project, index) => (
          <div
            key={project?.id || index}
            className="w-full flex items-center justify-between px-3 py-2 hover:bg-gray-50 border-b border-b-[#EFEFEF] rounded-lg"
          >
            <div className="flex items-center gap-2">
              <span className="font-normal text-[14px] text-[#4B5563]">
                {project?.title}
              </span>
            </div>
            <button
              onClick={() => handleDeleteProjectClick(project?.id)}
              className="font-medium text-[14px] text-[#E90C0C]"
            >
              Unassign project
            </button>
          </div>
        ))}
      </div>
      {isDeleteModalVisible && (
        <DeletConfirmation
          onClose={closeModal}
          deleteModal={handleDeleteClick}
          setDeleteModal={setIsDeleteModalVisible}
          handleDelete={handleDelete}
          isLoading={isLoading}
        />
      )}

      {isDeleteProjectVisible && (
        <DeletConfirmation
          onClose={closeModal}
          deleteModal={handleDeleteProjectClick}
          setDeleteModal={setIsDeleteProjectVisible}
          handleDelete={handleProjectDelete}
          isLoading={Loading}
          project={true}
        />
      )}

      <UpgradePromptModal
        show={showUpgradeModal}
        handleClose={() => setShowUpgradeModal(false)}
        featureName={restrictedFeature?.name}
        requiredPlan={restrictedFeature?.requiredPlan}
      />
    </div>
  );
};

export default WorkerProfile;
